module.exports = __webpack_public_path__ + "media/images/background_shop-db60c4248438fffd75f74c07b0331e11.png";